//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 1 => ADD/OVERWRITE PART DATA UNDER RESPECTIVE PROJECT
///
export const updateFloorMarkersInDatastore = (proid, floorMeta, floorMarkersList, projectDatastore) => {
    return {
        type: "ADD_FLOOR_MARKERS_PROJECT_DATASTORE",
        floorMarkersList,
        proid,
    }
}

export const testUpdateFloorMarkersInDatastore = (floorMeta, floorMarkersList, projectDatastore) => {
    const {proid, floorid} = floorMeta;

    switch (proid in projectDatastore) {
        case true: {
            projectDatastore[`${proid}`][`${floorid}`] = floorMarkersList;
            break;
        }
        default: {
            var floorMarkersMap = {
                [`${floorid}`]: floorMarkersList
            };
            projectDatastore[`${proid}`] = floorMarkersMap;
            break;
        }
    }

    return {
        type: "TEST_ADD_FLOOR_MARKERS_PROJECT_DATASTORE",
        projectDatastore,
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 2 => UTILS
///
